export default __webpack_public_path__ + "static/media/madhu-pandit-chairman.cdc560a9.png";